import React from 'react';
import { Typography, Button } from '@one-thd/sui-atomic-components';
import { SWEEPSTAKES_MOCK_DATA } from '../../../../../core/Data/SweepstakesMockData';
import { mapSweepstakesData } from '../../../utils/SweepstakesDataMapper';
import { gotoLogonModule } from '../../../../../common/utils/AccountUtils';

export const UnauthenticatedContent = () => {
  const data = mapSweepstakesData(SWEEPSTAKES_MOCK_DATA.unauthenticated);

  const handleSignIn = () => {
    gotoLogonModule();
  };

  const content = (
    <div>
      <Typography variant="body-base" data-testid="unauthenticated-description">
        {data.drawerDescription}
      </Typography>
    </div>
  );

  const footer = (
    <Button
      variant="primary"
      fullWidth
      onClick={handleSignIn}
      data-testid="unauthenticated-sign-in-button"
    >
      Sign In to Enter
    </Button>
  );

  return { content, footer };
};
